export const APP_SETTINGS_FETCH_SUCCESSFULLY = 'system.APP_SETTINGS_FETCH_SUCCESSFULLY';
export const APP_SETTINGS_FETCH_FAILED = 'system.APP_SETTINGS_FETCH_FAILED';
export const APP_SETTINGS_FETCH_TAGS = 'system.APP_SETTINGS_FETCH_TAGS';
